export var PrerequisiteTypeEnum;
(function (PrerequisiteTypeEnum) {
    PrerequisiteTypeEnum["ABILITY_SCORE"] = "ability-score";
    PrerequisiteTypeEnum["CUSTOM_VALUE"] = "custom-value";
    PrerequisiteTypeEnum["PROFICIENCY"] = "proficiency";
    PrerequisiteTypeEnum["RACE"] = "race";
    PrerequisiteTypeEnum["SIZE"] = "size";
    PrerequisiteTypeEnum["SUBRACE"] = "subrace";
    PrerequisiteTypeEnum["LEVEL"] = "level";
})(PrerequisiteTypeEnum || (PrerequisiteTypeEnum = {}));
export var PrerequisiteSubTypeEnum;
(function (PrerequisiteSubTypeEnum) {
    PrerequisiteSubTypeEnum["CHARACTER_LEVEL"] = "character-level";
})(PrerequisiteSubTypeEnum || (PrerequisiteSubTypeEnum = {}));
